import _ from 'lodash';
import moment from 'moment';
import GoalDataModel from '../model/goalDataModel';
import GoalActionMapModel from '../model/goalActionMapModel';
var GoalsDataParser = /** @class */ (function () {
    function GoalsDataParser() {
        this.goalsData = [];
        this.goalsActionMapData = {};
    }
    GoalsDataParser.prototype.parseGoalData = function (goalsResponseData) {
        this.goalsData = goalsResponseData.map(function (responseItem) {
            var isCustomGoal = /\(customized\)$/i.test(responseItem.goal_type || '');
            var goalType = responseItem.goal_type;
            return new GoalDataModel(responseItem.resource, responseItem.goal_action_id, goalType, responseItem.goal, responseItem.action, responseItem.status, parseInt(responseItem.percentage || '0'), responseItem.start_date, responseItem.target_date, responseItem.modification_date, responseItem.notes, responseItem.notes_list, responseItem.created_date, responseItem.current_version, isCustomGoal);
        });
        this.goalsData = _.orderBy(this.goalsData, function (o) {
            return moment(o.createdDate).format('YYYYMMDD');
        }, ['asc']);
        return this.goalsData;
    };
    GoalsDataParser.prototype.parseGoalActionMapData = function (goalActionMapResponse) {
        var _this = this;
        goalActionMapResponse.forEach(function (item) {
            var goalType = item.goal_name;
            var actions = {};
            if (!item.goal_actions || typeof item.goal_actions !== 'object') {
                return;
            }
            Object.entries(item.goal_actions).forEach(function (_a) {
                var goalLevelAction = _a[0], subActionList = _a[1];
                if (!Array.isArray(subActionList))
                    return;
                var subActions = {};
                subActionList.forEach(function (subAction) {
                    if (!subAction)
                        return;
                    subActions[subAction] = {
                        actionName: subAction,
                        selected: false,
                        rowId: [],
                    };
                });
                actions[goalLevelAction] = {
                    actionName: goalLevelAction,
                    selected: false,
                    rowId: [],
                    subActions: subActions,
                };
            });
            _this.goalsActionMapData[goalType] = new GoalActionMapModel(goalType, false, actions, []);
        });
        return this.goalsActionMapData;
    };
    return GoalsDataParser;
}());
export default GoalsDataParser;
